import ScheduleCalendarDay from "@/schedule/entities/schedule-calendar-day";

export default class ScheduleCell {
  userId: number;
  date: Date;
  icon: string = "";
  variant: string = "";

  public constructor(day: ScheduleCalendarDay, projectId?: number) {
    this.userId = day.userId;
    this.date = day.date;
    if (day.events.length > 1) {
      this.icon = "fas fa-xs fa-clone";
    }
    if (day.events.length === 0) {
      this.variant = "";
    } else if (!projectId || day.events.some(e => e.projectId === projectId)) {
      this.variant = "primary";
    } else {
      this.variant = "secondary";
    }
  }
}
